import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@chapche/ui';

const DeleteModalContent = ({ handleDelete, handleClose, tab, itemTitle, isForceDelete }) => {
    const { i18n } = useTranslation();
    return (
        <>
            <h2 className="modal__title modal__title_align block__title-h3">{i18n.t(`app.page.product.modal.${tab}.title`)}</h2>
            <p className="block__content modal__text modal__text_align">
                {isForceDelete ?
                    i18n.t(`app.page.product.modal.${tab}.forceDelete.content`) + ` ${itemTitle}?`
                    :
                    `${i18n.t(`app.page.product.modal.${tab}.content`).slice(0, -1)} ${itemTitle ? itemTitle : ''}?`}
            </p>
            <div className="modal__button-group">
                <Button variant="outline" onClick={() => handleClose(null)}>
                    {i18n.t(`app.page.product.modal.${tab}.cancel`)}
                </Button>
                <Button onClick={handleDelete}>
                    {i18n.t(`app.page.product.modal.${tab}.delete`)}
                </Button>
            </div>
        </>
    )
};

export default DeleteModalContent;
